const pagesIndividualCommonEn = {
  empty: 'No items to display',
  filterTabsLabel: 'Filter',
  forbidden: {
    backToLookup: 'Back to Inquiry & Reference',
    description: "You don't have permission to view this page.",
    title: 'Access denied'
  },
  search: 'Search'
};
export default pagesIndividualCommonEn;